import { useErrorHandling } from '@/composables'
import { ENDPOINTS } from '@/endpoints'
import { type APIResponse } from '@/types'
import type { MarketDataPopulationAgeGender, MarketDataMedianAgePopulation, MarketDataPopulationGrowthRate, MarketDataLifeExpectancy } from '@/types'
import axios, { type GenericAbortSignal } from 'axios'

export const getMarketDataPopulationAgeGender = async (
    year?: string,
    signal?: GenericAbortSignal,
) => {
    const request = axios.get<APIResponse<MarketDataPopulationAgeGender>>(
        `${ENDPOINTS.MARKET_DATA_V1}/demographic/age-gender-population?year=${year}`,
        { signal, suppressToast: !!signal },
    )

    const response = await useErrorHandling(request)

    return response.data.data
}

export const getMarketDataMedianAgePopulation = async ( signal?: GenericAbortSignal ) => {
    const request = axios.get<APIResponse<MarketDataMedianAgePopulation>>(
        `${ENDPOINTS.MARKET_DATA_V1}/demographic/median-age-population`,
        { signal, suppressToast: !!signal },
    )

    const response = await useErrorHandling(request)

    return response.data.data
}

export const getMarketDataPopulationGrowthRate = async ( signal?: GenericAbortSignal ) => {
    const request = axios.get<APIResponse<MarketDataPopulationGrowthRate>>(
        `${ENDPOINTS.MARKET_DATA_V1}/demographic/population-growth-rate`,
        { signal, suppressToast: !!signal },
    )

    const response = await useErrorHandling(request)

    return response.data.data
}

export const getMarketDataLifeExpectancy = async ( signal?: GenericAbortSignal ) => {
    const request = axios.get<APIResponse<MarketDataLifeExpectancy>>(
        `${ENDPOINTS.MARKET_DATA_V1}/demographic/life-expectancy`,
        { signal, suppressToast: !!signal },
    )

    const response = await useErrorHandling(request)

    return response.data.data
}
